import { useEffect } from 'react';
import { useHub } from '@/contexts/HubProvider';

export function HubSetter() {
  const { currentHubData } = useHub();
  const hubId = currentHubData?.hub?.id;

  useEffect(() => {
    if (hubId) {
      window.__currentHubId = hubId;
      console.log("[HubSetter] window.__currentHubId =", hubId);
    } else {
      window.__currentHubId = undefined;
    }
  }, [hubId]);

  return null; // This component doesn't render anything
}
